export default "__VITE_PUBLIC_ASSET__7dc650ad__"